var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleArticle',{attrs:{"bodytext":_vm.bodytext}},[_c('ScPlaceholder',{attrs:{"name":"jss-content","rendering":_vm.rendering}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }